<template>
  <div>
    <vue-element-loading is-full-screen :active="true" spinner="bar-fade-scale" color="#152d51" />
  </div>
</template>

<script>
import api from "@/api";
import VueElementLoading from "vue-element-loading";
export default {
  components: { VueElementLoading },
  data() {
    return {
      userData: {},
    };
  },
  computed: {
    query() {
      return this.$store.state.query;
    },
    userId() {
      return this.$store.state.profile.userId;
    },
    regised() {
      if (this.userId && this.userData && this.userData.cardnumber && this.userData.status == "ผูกบัญชีแล้ว") {
        return true;
      } else {
        return false;
      }
    },
  },
  watch: {
    userId: {
      immediate: true,
      handler(userId) {
        if (userId) {
          this.setup();
        }
      },
    },
  },
  mounted() {
    let { apptype } = this.$route.query;
    if (apptype != "line") {
      this.$router.push("/updateAddressNoRegisAuth");
    }
  },
  methods: {
    async setup() {
      await this.fetchUserData(this.userId);
      if (this.userId && this.userData && this.userData.cardnumber && this.userData.status == "ผูกบัญชีแล้ว") {
        this.$router.push("/checkOtpUpdateAddress");
      } else {
        this.$router.push("/updateAddressNoRegisAuth");
      }
    },
    async fetchUserData(userId) {
      if (userId) {
        let res = await api.getUser(userId);
        if (res.responsecode == 200 && res.data.id) {
          this.userData = res.data;
          this.$store.dispatch("setUserData", this.userData);
        } else {
          console.log("error fetch user data");
        }
      }
    },
  },
};
</script>
